import React from 'react';
import FloatingLabel from 'floating-label-react';
import NumberFormat from 'react-number-format';
import { Field } from 'formik';

export default ({
  name,
  placeholder,
  showErrorMessages = true,
  format,
  maxLength,
  onChangeHandler,
  floating = true,
  displayType,
  thousandSeparator,
  decimalScale,
  decimalSeparator,
  fixedDecimalScale,
  allowedDecimalSeparators,
  disabled,
  prefix,
  suffix,
  callBackFun
}) => {
  if (maxLength === undefined) {
    maxLength = 12
  }

  const MAX_VAL = 4000;
  const withValueLimit = (inputObj, name) => {
    const { value } = inputObj;
    if (value >= 0 && value <= MAX_VAL) return true;

    return false;
  };

  const valueLimitHundred = (inputObj, name) => {
    const { value } = inputObj;
    if (value >= 0 && value <= 200) return true;

    return false;
  };

  const withValue = (inputObj) => {
    const { value } = inputObj;
    if (name === "endAfterOccurrences") {
      if (value >= 0 && value <= 10) return true;
    } else {
      return true;
    }
  };

  return (
    <Field name={name}>
      {({ field, form, meta }) => (
        <div className='app-input-text'>
          <NumberFormat
            prefix={prefix}
            suffix={suffix}
            placeholder={placeholder}
            format={format}
            fixedDecimalScale={fixedDecimalScale}
            decimalScale={decimalScale}
            decimalSeparator={decimalSeparator}
            displayType={displayType}
            disabled={disabled}
            allowNegative={false}
            thousandSeparator={thousandSeparator}
            allowedDecimalSeparators={allowedDecimalSeparators}
            maxLength={maxLength}
            isAllowed={name === "pickupMiles" || name === "distanceWillingToTravel" ? withValueLimit :
              name === "basePrice" || name === "desiredPrice" || name === "cpuPrice" ? valueLimitHundred : withValue}
            onValueChange={(e) => {
              if (onChangeHandler !== undefined)
                onChangeHandler(e.value)

              if (name === "endAfterOccurrences") callBackFun(e.value)
            }}
            name={field.name}
            className={`${meta.touched && meta.error ? 'error' : ''}`}
            {...field}
          />
          {meta.touched && meta.error && showErrorMessages && (
            <p name={name + 'Error'} className='error-message'>{meta.error}</p>
          )}
        </div>
      )}
    </Field>
  );
}
